/* AlpenThermo UI - közös interakciók az at-* szekciókhoz */
(function () {
  'use strict';
  /* egyszer fusson akkor is, ha több szekció is betöltené */
  if (window.__atUi) return; window.__atUi = 1;
  if (window.__atUI) return; window.__atUI = true;
  var money = function (cents) {
    var v = Math.round(cents / 100);
    return v.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ' Ft';
  };
  window.atMoney = money;

  /* ---------- megjelenés görgetéskor ---------- */
  function reveal(root) {
    var els = (root || document).querySelectorAll('.at-reveal:not(.is-in)');
    if (!('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (e) { io.observe(e); });
  }

  /* ---------- modál (videó / kép) ---------- */
  var modal;
  function getModal() {
    if (modal) return modal;
    modal = document.createElement('div');
    modal.className = 'at at-modal'; modal.setAttribute('role', 'dialog'); modal.setAttribute('aria-modal', 'true');
    modal.innerHTML = '<div class="at-modal__box"><button type="button" class="at-modal__x" aria-label="Bezárás">✕</button><div class="at-modal__c"></div><div class="at-modal__cap"></div></div>';
    document.body.appendChild(modal);
    modal.addEventListener('click', function (e) { if (e.target === modal || e.target.closest('.at-modal__x')) closeModal(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeModal(); });
    return modal;
  }
  function closeModal() {
    if (!modal) return;
    modal.classList.remove('is-open');
    modal.querySelector('.at-modal__c').innerHTML = '';
    document.documentElement.style.overflow = '';
  }
  function openModal(html, cap) {
    var m = getModal();
    m.querySelector('.at-modal__c').innerHTML = html;
    m.querySelector('.at-modal__cap').textContent = cap || '';
    m.classList.add('is-open');
    document.documentElement.style.overflow = 'hidden';
    var v = m.querySelector('video');
    if (v) {
      v.muted = true; v.volume = 0;
      v.addEventListener('volumechange', function () { if (!v.muted) v.muted = true; });
      v.addEventListener('click', function (e) { e.stopPropagation(); if (v.paused) v.play(); else v.pause(); });
      var p = v.play(); if (p && p.catch) p.catch(function () {});
    }
  }
  document.addEventListener('click', function (e) {
    var v = e.target.closest('[data-at-video]');
    if (v) { e.preventDefault(); openModal('<video src="' + v.getAttribute('data-at-video') + '" muted playsinline autoplay loop disablepictureinpicture' + (v.dataset.atPoster ? ' poster="' + v.dataset.atPoster + '"' : '') + '></video>', v.getAttribute('data-at-cap')); return; }
    var i = e.target.closest('[data-at-img]');
    if (i) { e.preventDefault(); openModal('<img src="' + i.getAttribute('data-at-img') + '" alt="">', i.getAttribute('data-at-cap')); }
  });

  /* ---------- videó előnézetek: csak ha látszanak ---------- */
  function lazyVids() {
    var vs = document.querySelectorAll('video[data-at-lazy]:not([src])');
    function go(v) { v.preload = 'metadata'; v.src = v.getAttribute('data-at-lazy'); }
    if (!('IntersectionObserver' in window)) { vs.forEach(go); return; }
    var io = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { io.unobserve(e.target); go(e.target); } }); }, { rootMargin: '200px' });
    vs.forEach(function (v) { io.observe(v); });
  }

  /* ---------- hero videó ---------- */
  function heroes() {
    document.querySelectorAll('[data-at-hero]').forEach(function (h) {
      if (h.dataset.atInit) return; h.dataset.atInit = 1;
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var mq = window.matchMedia('(min-width: 750px)');
      var vids = h.querySelectorAll('video[data-src]');
      function load() {
        vids.forEach(function (v) {
          var want = v.classList.contains('at-hero__v--d') ? mq.matches : !mq.matches;
          if (want && !v.src) { v.src = v.dataset.src; v.load(); }
          if (want && !reduce) { var p = v.play(); if (p && p.catch) p.catch(function () {}); } else { v.pause(); }
        });
      }
      /* ha a gépes/telefonos videó fordítva lett megadva, képarány alapján megcseréli */
      var vd = h.querySelector('.at-hero__v--d'), vm = h.querySelector('.at-hero__v--m');
      if (vd && vm && vd.dataset.src !== vm.dataset.src) {
        [vd, vm].forEach(function (v) {
          v.addEventListener('loadedmetadata', function () {
            if (h.dataset.atSwapped || !v.videoWidth) return;
            var portrait = v.videoHeight > v.videoWidth;
            if ((v === vd && portrait) || (v === vm && !portrait)) {
              h.dataset.atSwapped = 1;
              var a = vd.dataset.src; vd.dataset.src = vm.dataset.src; vm.dataset.src = a;
              var pa = vd.getAttribute('poster'), pb = vm.getAttribute('poster');
              if (pa && pb) { vd.setAttribute('poster', pb); vm.setAttribute('poster', pa); }
              v.src = v.dataset.src; v.load(); if (!reduce) { var pr = v.play(); if (pr && pr.catch) pr.catch(function () {}); }
            }
          });
        });
      }
      load(); mq.addEventListener ? mq.addEventListener('change', load) : mq.addListener(load);
      var t = h.querySelector('.at-hero__toggle');
      if (t) t.addEventListener('click', function () {
        var on = Array.prototype.some.call(vids, function (v) { return !v.paused; });
        vids.forEach(function (v) { if (on) v.pause(); else if (v.src) v.play(); });
        t.setAttribute('aria-label', on ? 'Lejátszás' : 'Szünet'); t.innerHTML = on ? '▶' : '❚❚';
      });
    });
  }

  /* ---------- termékrács: fülek + színpöttyök ---------- */
  function grids() {
    document.querySelectorAll('[data-at-pgrid]').forEach(function (g) {
      if (g.dataset.atInit) return; g.dataset.atInit = 1;
      var tabs = g.querySelectorAll('[data-at-tab]'), cards = g.querySelectorAll('[data-at-card]');
      tabs.forEach(function (b) {
        b.addEventListener('click', function () {
          tabs.forEach(function (x) { x.classList.toggle('is-on', x === b); x.setAttribute('aria-pressed', x === b); });
          var hs = (b.dataset.atTab || '').split(',').filter(Boolean);
          cards.forEach(function (c) { c.hidden = hs.length > 0 && hs.indexOf(c.dataset.handle) === -1; });
        });
      });
      g.addEventListener('click', function (e) {
        var s = e.target.closest('[data-at-sw]'); if (!s) return;
        e.preventDefault();
        var card = s.closest('[data-at-card]'), img = card.querySelector('.at-pcard__img img');
        card.querySelectorAll('[data-at-sw]').forEach(function (x) { x.classList.toggle('is-on', x === s); });
        if (img) {
          if (!img.dataset.orig) { img.dataset.orig = img.getAttribute('src'); img.dataset.origSet = img.getAttribute('srcset') || ''; }
          if (s.dataset.img) { img.removeAttribute('srcset'); img.removeAttribute('sizes'); img.src = s.dataset.img; card.classList.add('is-sw'); }
          else { img.src = img.dataset.orig; if (img.dataset.origSet) img.setAttribute('srcset', img.dataset.origSet); card.classList.remove('is-sw'); }
        }
        var a = card.querySelector('.at-pcard__title'); if (a && s.dataset.url) a.href = s.dataset.url;
      });
    });
  }

  /* ---------- kosárba (több tétel) ---------- */
  function addItems(items) {
    return fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); });
  }
  window.atAddItems = addItems;

  /* ---------- csomagok ---------- */
  function bundles() {
    document.querySelectorAll('[data-at-bundle]').forEach(function (b) {
      if (b.dataset.atInit) return; b.dataset.atInit = 1;
      var sum = b.querySelector('[data-at-sum]'), btn = b.querySelector('[data-at-bundle-add]');
      function recalc() {
        var t = 0; b.querySelectorAll('select[data-at-v]').forEach(function (s) { t += +s.selectedOptions[0].dataset.price; });
        var pct = parseFloat(b.dataset.pct) || 0, fin = Math.round(t * (100 - pct) / 100 / 100) * 100;
        var old = b.querySelector('[data-at-sum-old]'), save = b.querySelector('[data-at-save]');
        if (sum) sum.textContent = money(pct ? fin : t);
        if (old) { old.hidden = !pct; old.textContent = money(t); }
        if (save) { save.hidden = !pct; save.textContent = 'Megtakarítás: ' + money(t - fin); }
        var any = Array.prototype.some.call(b.querySelectorAll('select[data-at-v]'), function (s) { return s.selectedOptions[0].disabled; });
        if (btn) btn.disabled = any;
      }
      b.addEventListener('change', recalc); recalc();
      if (btn) btn.addEventListener('click', function () {
        var items = []; b.querySelectorAll('select[data-at-v]').forEach(function (s) { items.push({ id: +s.value, quantity: 1 }); });
        btn.disabled = true; var lbl = btn.textContent; btn.textContent = 'Hozzáadás…';
        addItems(items).then(function () { window.location.href = (window.routes && window.routes.cart_url) || '/cart'; })
          .catch(function (err) { btn.disabled = false; btn.textContent = lbl; alert((err && err.description) || 'Hiba történt, próbáld újra.'); });
      });
    });
  }

  /* ---------- galéria: továbbiak ---------- */
  document.addEventListener('click', function (e) {
    var m = e.target.closest('[data-at-more]'); if (!m) return;
    var g = document.getElementById(m.dataset.atMore); if (g) { g.classList.add('is-all'); m.remove(); }
  });

  /* ---------- termékoldal: fő űrlap segédek ---------- */
  function mainForm() {
    return document.querySelector('product-info form[data-type="add-to-cart-form"]') || document.querySelector('form[action*="/cart/add"][data-type="add-to-cart-form"]');
  }
  function productData() {
    var el = document.getElementById('at-product-json'); if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }
  function currentVariant() {
    var f = mainForm(), d = productData(); if (!f || !d) return null;
    var id = +((f.querySelector('input[name="id"]') || {}).value || 0);
    for (var i = 0; i < d.variants.length; i++) if (d.variants[i].id === id) return d.variants[i];
    return d.variants[0];
  }
  function submitMain() {
    var f = mainForm(); if (!f) return;
    if (f.checkValidity && !f.checkValidity()) { f.scrollIntoView({ behavior: 'smooth', block: 'center' }); f.reportValidity && f.reportValidity(); return false; }
    var s = f.querySelector('[type="submit"][name="add"]') || f.querySelector('[type="submit"]');
    if (f.requestSubmit) f.requestSubmit(s || undefined); else if (s) s.click();
    return true;
  }

  /* ---------- gyakran együtt ---------- */
  function fbt() {
    document.querySelectorAll('[data-at-fbt]').forEach(function (b) {
      if (b.dataset.atInit) return; b.dataset.atInit = 1;
      var tot = b.querySelector('[data-at-fbt-total]'), btn = b.querySelector('[data-at-fbt-add]'), msg = b.querySelector('[data-at-fbt-msg]');
      var deal = b.querySelector('[data-at-fbt-deal]'), old = b.querySelector('[data-at-fbt-old]');
      var d2 = +b.dataset.d2 || 0, d3 = +b.dataset.d3 || 0;
      function recalc() {
        var v = currentVariant(), q = document.querySelector('product-info input[name="quantity"]');
        var mq = Math.max(1, parseInt(q && q.value, 10) || 1);
        var t = v ? v.price * mq : 0, n = 1, cnt = mq, base = t, extra = 0;
        b.querySelectorAll('[data-at-fbt-item]').forEach(function (it) {
          var c = it.querySelector('input[type=checkbox]'), s = it.querySelector('select'), px = it.querySelector('[data-at-fbt-px]');
          if (px && s.selectedOptions[0]) px.textContent = money(+s.selectedOptions[0].dataset.price);
          if (c.checked) { var pr = +s.selectedOptions[0].dataset.price; t += pr; n++; if (it.hasAttribute('data-nocount')) extra += pr; else { cnt++; base += pr; } }
        });
        /* extra kedvezmény a darabszám szerint (a tisztítókefe nem számít bele) */
        var pct = cnt >= 3 ? d3 : cnt === 2 ? d2 : 0, fin = Math.round((base * (100 - pct) / 100 + extra) / 100) * 100;
        if (tot) tot.textContent = money(pct ? fin : t);
        if (old) { old.hidden = !pct; old.textContent = money(t); }
        if (deal) {
          var nxt = cnt < 2 ? d2 : cnt < 3 ? d3 : 0, need = cnt < 2 ? 2 - cnt : 3 - cnt;
          deal.className = 'at-fbt__deal' + (pct ? ' is-on' : '');
          deal.innerHTML = pct
            ? '<b>✓ Ingyenes szállítás + extra ' + pct + '% kedvezmény</b><span>Megtakarítás: ' + money(t - fin) + '</span>' + (nxt ? '<small>Még ' + need + ' termék, és extra ' + nxt + '% kedvezmény jár.</small>' : '')
            : '<b>Válassz mellé még ' + need + ' terméket:</b><span>ingyenes szállítás + extra ' + nxt + '% kedvezmény</span>';
        }
        if (btn) btn.textContent = n > 1 ? (b.dataset.lblMany || 'Mind a ' + n + ' kosárba') : (b.dataset.lblOne || 'Kosárba');
      }
      b.addEventListener('change', function (e) { if (e.target.matches('select')) { var it = e.target.closest('[data-at-fbt-item]'), c = it && it.querySelector('input[type=checkbox]'); if (c && !c.checked) c.checked = true; } recalc(); });
      document.addEventListener('click', function (e) { if (e.target.closest('quantity-input')) setTimeout(recalc, 60); });
      document.addEventListener('change', function (e) { if (e.target.closest('product-info') && !e.target.closest('[data-at-fbt]')) setTimeout(recalc, 60); });
      recalc();
      if (btn) btn.addEventListener('click', function () {
        var f = mainForm(); if (f && f.checkValidity && !f.checkValidity()) { submitMain(); return; }
        var items = [];
        b.querySelectorAll('[data-at-fbt-item]').forEach(function (it) {
          var c = it.querySelector('input[type=checkbox]'), s = it.querySelector('select');
          if (c.checked && !s.selectedOptions[0].disabled) items.push({ id: +s.value, quantity: 1 });
        });
        if (!items.length) { submitMain(); return; }
        btn.disabled = true;
        addItems(items).then(function () { btn.disabled = false; submitMain(); })
          .catch(function (err) { btn.disabled = false; if (msg) msg.textContent = (err && err.description) || 'Hiba történt, próbáld újra.'; });
      });
    });
  }


  /* ---------- 24 órás teszt (összehasonlítás) ---------- */
  function vt() {
    document.querySelectorAll('[data-at-vt]').forEach(function (root) {
      if (root.dataset.atInit) return; root.dataset.atInit = 1;
      var range = root.querySelector('[data-at-vt-range]'), hEl = root.querySelector('[data-at-vt-h]'), ticks = root.querySelector('[data-at-vt-ticks]');
      var A = root.querySelector('[data-side="a"]'), B = root.querySelector('[data-side="b"]');
      var mode = 'cold', played = false, anim = null, C = +root.dataset.cold || 24, H = +root.dataset.hot || 12;
      function lerp(a, b, x) { return a + (b - a) * Math.max(0, Math.min(1, x)); }
      function mix(c1, c2, x) {
        var a = c1.match(/\w\w/g).map(function (h) { return parseInt(h, 16); }), b = c2.match(/\w\w/g).map(function (h) { return parseInt(h, 16); });
        return 'rgb(' + a.map(function (v, i) { return Math.round(lerp(v, b[i], x)); }).join(',') + ')';
      }
      function set(el, o) {
        for (var k in o) if (k.charAt(0) === '-') el.style.setProperty(k, o[k]);
        el.querySelector('.at-vt__state').textContent = o.state; el.querySelector('.at-vt__note').textContent = o.note;
      }
      function draw() {
        var t = +range.value, max = +range.max;
        hEl.textContent = (Math.round(t * 10) / 10).toString().replace('.', ',');
        range.style.setProperty('--p', (t / max * 100) + '%');
        if (mode === 'cold') {
          set(A, { '--lvl': lerp(14, 22, t / C) + '%', '--ice': lerp(1, .55, t / C), '--drop': 0, '--steam': 0, '--liq': '#bfe6fa', '--tcol': '#5fb8e8', state: 'Jéghideg', note: 'Kívül száraz' });
          var x = Math.min(t / 6, 1);
          set(B, { '--lvl': lerp(14, 72, x) + '%', '--ice': Math.max(0, 1 - t / 3), '--drop': t < .3 ? 0 : Math.min(1, (t - .3) / 1.2), '--steam': 0, '--liq': mix('bfe6fa', 'e9eef1', x), '--tcol': mix('5fb8e8', 'f2a26b', x),
            state: t < 1 ? 'Jéghideg' : t < 3 ? 'Hűvös' : t < 6 ? 'Langyos' : 'Meleg', note: t < .3 ? 'Kívül száraz' : 'Kívül izzad, vizes a táska' });
        } else {
          set(A, { '--lvl': lerp(88, 74, t / H) + '%', '--ice': 0, '--drop': 0, '--steam': lerp(1, .55, t / H), '--liq': '#b8794a', '--tcol': '#e76a6a', state: 'Forró', note: 'Kívül nem éget' });
          var y = Math.min(t / 4, 1);
          set(B, { '--lvl': lerp(88, 30, y) + '%', '--ice': 0, '--drop': 0, '--steam': Math.max(0, 1 - t / 1.5), '--liq': mix('b8794a', 'c7a68a', y), '--tcol': mix('e76a6a', '5fb8e8', y),
            state: t < .75 ? 'Forró' : t < 2 ? 'Meleg' : t < 4 ? 'Langyos' : 'Kihűlt', note: t < 1 ? 'Kívül is forró' : t < 4 ? 'Gyorsan hűl' : 'A kávé kihűlt' });
        }
      }
      function setMode(m) {
        mode = m; root.dataset.mode = m;
        root.querySelectorAll('[data-mode]').forEach(function (b) { var on = b.dataset.mode === m; b.classList.toggle('is-on', on); b.setAttribute('aria-selected', on); });
        var max = m === 'cold' ? C : H; range.max = max; range.value = 0;
        ticks.innerHTML = [0, .25, .5, .75, 1].map(function (f, i) { return '<span>' + String(Math.round(f * max * 10) / 10).replace('.', ',') + (i === 0 || i === 4 ? ' ó' : '') + '</span>'; }).join('');
        draw(); play();
      }
      function play() {
        if (anim) cancelAnimationFrame(anim);
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) { range.value = range.max; draw(); return; }
        var t0 = null, dur = 3600, max = +range.max;
        function step(ts) { if (!t0) t0 = ts; var x = Math.min(1, (ts - t0) / dur); x = 1 - Math.pow(1 - x, 3); range.value = x * max; draw(); if (x < 1) anim = requestAnimationFrame(step); }
        anim = requestAnimationFrame(step);
      }
      range.addEventListener('input', function () { if (anim) cancelAnimationFrame(anim); draw(); });
      range.addEventListener('pointerdown', function () { if (anim) cancelAnimationFrame(anim); });
      root.querySelectorAll('[data-mode]').forEach(function (b) { b.addEventListener('click', function () { setMode(b.dataset.mode); }); });
      range.max = C; ticks.innerHTML = [0, .25, .5, .75, 1].map(function (f, i) { return '<span>' + String(Math.round(f * C * 10) / 10).replace('.', ',') + (i === 0 || i === 4 ? ' ó' : '') + '</span>'; }).join('');
      draw();
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting && !played) { played = true; io.disconnect(); setTimeout(play, 300); } }); }, { threshold: .45 });
        io.observe(root);
      }
    });
  }


  /* ---------- videósáv nyilak ---------- */
  function vwraps() {
    document.querySelectorAll('[data-at-vwrap]').forEach(function (w) {
      if (w.dataset.atInit) return; w.dataset.atInit = 1;
      var wall = w.querySelector('.at-vwall'), prev = w.querySelector('[data-at-vprev]'), next = w.querySelector('[data-at-vnext]');
      if (!wall) return;
      function step() { var c = wall.querySelector('.at-vcard'); if (!c) return wall.clientWidth; var gap = parseFloat(getComputedStyle(wall).columnGap) || 12; var per = Math.max(1, Math.floor((wall.clientWidth + gap) / (c.offsetWidth + gap))); return per * (c.offsetWidth + gap); }
      function upd() { var max = wall.scrollWidth - wall.clientWidth - 2; prev.disabled = wall.scrollLeft <= 2; next.disabled = wall.scrollLeft >= max; }
      prev.addEventListener('click', function () { wall.scrollBy({ left: -step(), behavior: 'smooth' }); });
      next.addEventListener('click', function () { wall.scrollBy({ left: step(), behavior: 'smooth' }); });
      wall.addEventListener('scroll', function () { window.requestAnimationFrame(upd); }, { passive: true });
      window.addEventListener('resize', upd); upd();
    });
  }

  /* ---------- tapadó kosársáv ---------- */
  function sticky() {
    var s = document.querySelector('[data-at-sticky]'); if (!s || s.dataset.atInit) return; s.dataset.atInit = 1;
    var f = mainForm(); if (!f) return;
    var anchor = f.querySelector('[type="submit"]') || f;
    var img = s.querySelector('img'), price = s.querySelector('[data-at-sticky-price]'), vt = s.querySelector('[data-at-sticky-variant]'), btn = s.querySelector('[data-at-sticky-btn]');
    function upd() {
      var v = currentVariant(); if (!v) return;
      if (price) price.textContent = money(v.price);
      if (vt) vt.textContent = v.title === 'Default Title' ? '' : v.title;
      if (img && v.image) img.src = v.image;
      if (btn) { btn.disabled = !v.available; btn.textContent = v.available ? (s.dataset.lbl || 'Kosárba') : (s.dataset.lblSold || 'Elfogyott'); }
    }
    document.addEventListener('change', function (e) { if (e.target.closest('product-info')) setTimeout(upd, 60); });
    upd();
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) { es.forEach(function (e) { var below = e.boundingClientRect.top < 0; s.classList.toggle('is-on', !e.isIntersecting && below); }); }).observe(anchor);
    }
    if (btn) btn.addEventListener('click', function () { submitMain(); });
  }


  /* ---------- termékoldal: valódi Judge.me vélemények, képesek elöl ---------- */
  function jr() {
    document.querySelectorAll('[data-at-jr]').forEach(function (grid) {
      if (grid.dataset.atInit) return; grid.dataset.atInit = 1;
      var sec = grid.closest('section'), more = sec.querySelector('[data-at-jr-more]'), write = sec.querySelector('[data-at-jr-write]'), app = sec.querySelector('[data-at-jr-app]');
      var step = +grid.dataset.step || 6, shown = 0, list = [];
      if (write && app) write.addEventListener('click', function () {
        var open = app.hidden; app.hidden = !open; write.setAttribute('aria-expanded', open);
        if (!open) return;
        app.classList.add('is-form');
        var form = app.querySelector('.jdgm-form-wrapper, .jdgm-form'), btn = app.querySelector('.jdgm-write-rev-link');
        if (btn && (!form || form.offsetParent === null)) btn.click();
        setTimeout(function () { app.scrollIntoView({ behavior: 'smooth', block: 'start' }); }, 60);
      });
      function esc(t) { var d = document.createElement('div'); d.textContent = t || ''; return d.innerHTML; }
      function fallback() { grid.hidden = true; if (typeof less !== 'undefined' && less) less.hidden = true; if (more) more.hidden = true; if (write) write.hidden = true; if (app) { app.hidden = false; app.classList.remove('is-form'); } }
      function page(n) {
        var u = 'https://api.judge.me/reviews/reviews_for_widget?url=' + encodeURIComponent(grid.dataset.shop) + '&shop_domain=' + encodeURIComponent(grid.dataset.shop) +
          '&platform=shopify&page=' + n + '&per_page=30&product_id=' + grid.dataset.pid;
        return fetch(u).then(function (r) { if (!r.ok) throw r; return r.json(); });
      }
      function parse(html) {
        var d = document.createElement('div'); d.innerHTML = html || '';
        return [].map.call(d.querySelectorAll('.jdgm-rev'), function (r) {
          var q = function (s) { var e = r.querySelector(s); return e ? e.textContent.trim() : ''; };
          var sc = r.querySelector('[data-score]');
          var pics = [].map.call(r.querySelectorAll('.jdgm-rev__pic-link'), function (a) {
            var im = a.querySelector('img'); return { t: (im && (im.getAttribute('data-src') || im.getAttribute('src'))) || a.getAttribute('href'), f: a.getAttribute('data-mfp-src') || a.getAttribute('href') };
          }).filter(function (p) { return p.t; });
          return { id: r.getAttribute('data-review-id'), name: q('.jdgm-rev__author'), v: r.getAttribute('data-verified-buyer') === 'true', s: sc ? +sc.getAttribute('data-score') : 5, title: q('.jdgm-rev__title'), body: q('.jdgm-rev__body'), pics: pics };
        });
      }
      function card(r) {
        var a = document.createElement('article'); a.className = 'at-rcard at-jr__card';
        var stars = ''; for (var i = 0; i < 5; i++) stars += i < r.s ? '★' : '☆';
        var pics = '';
        if (r.pics.length) {
          pics = '<div class="at-jr__pics' + (r.pics.length > 1 ? ' is-multi' : '') + '">' + r.pics.slice(0, 4).map(function (p, i) {
            return '<button type="button" data-at-img="' + esc(p.f) + '" data-at-cap="' + esc(r.name) + '" aria-label="Kép nagyítása"><img src="' + esc(p.t) + '" alt="' + esc(r.name) + ' képe" loading="lazy"></button>';
          }).join('') + '</div>';
        }
        a.innerHTML = '<div class="at-stars">' + stars + '</div>' + pics +
          (r.title ? '<h3>' + esc(r.title) + '</h3>' : '') + (r.body ? '<p>' + esc(r.body) + '</p>' : '') +
          '<div class="at-rcard__who"><i>' + esc(r.name.charAt(0)) + '</i><span>' + esc(r.name) + (r.v ? '<small>' + esc(grid.dataset.verified) + '</small>' : '') + '</span></div>';
        return a;
      }
      /* elsőre `step` db; a gomb lefelé +20-at nyit, utána oldalakra bontva (oldalanként step+20) */
      var PER = step + 20, pg = 0, pager = document.createElement('nav');
      pager.className = 'at-jr__pager'; pager.setAttribute('aria-label', 'Vélemények oldalai'); pager.hidden = true;
      grid.parentNode.insertBefore(pager, grid.nextSibling);
      var less = document.createElement('button'); less.type = 'button'; less.className = 'at-jr__less'; less.hidden = true;
      less.innerHTML = 'Vélemények összecsukása <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 15l7-7 7 7"/></svg>';
      if (more) more.parentNode.insertBefore(less, more.nextSibling); else pager.parentNode.insertBefore(less, pager.nextSibling);
      function teaser() { grid.innerHTML = ''; list.slice(0, step).forEach(function (r) { grid.appendChild(card(r)); }); shown = Math.min(step, list.length); if (more) more.hidden = list.length <= step; less.hidden = true; pager.hidden = true; pg = 0; }
      function expand() {
        list.slice(shown, PER).forEach(function (r) { grid.appendChild(card(r)); }); shown = Math.min(PER, list.length);
        if (more) more.hidden = true; pg = 1; drawPager(); less.hidden = false;
      }
      less.addEventListener('click', function () {
        teaser();
        var y = sec.getBoundingClientRect().top + window.pageYOffset - 80; window.scrollTo({ top: y, behavior: 'smooth' });
      });
      function goPage(n) {
        var pages = Math.ceil(list.length / PER); n = Math.max(1, Math.min(pages, n)); if (n === pg) return;
        pg = n; grid.innerHTML = ''; list.slice((n - 1) * PER, n * PER).forEach(function (r) { grid.appendChild(card(r)); });
        drawPager();
        var y = sec.getBoundingClientRect().top + window.pageYOffset - 80; window.scrollTo({ top: y, behavior: 'smooth' });
      }
      function drawPager() {
        var pages = Math.ceil(list.length / PER); pager.hidden = pages < 2; if (pages < 2) return;
        var nums = [], i;
        for (i = 1; i <= pages; i++) if (i === 1 || i === pages || Math.abs(i - pg) <= 1) nums.push(i); else if (nums[nums.length - 1] !== '…') nums.push('…');
        var arrow = function (dir, dis) { return '<button type="button" class="at-jr__pg at-jr__pg--arr" data-pg="' + (pg + dir) + '"' + (dis ? ' disabled' : '') + ' aria-label="' + (dir < 0 ? 'Előző' : 'Következő') + ' oldal"><svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="' + (dir < 0 ? 'M14.5 4.5L8 12l6.5 7.5' : 'M9.5 4.5L16 12l-6.5 7.5') + '"/></svg></button>'; };
        pager.innerHTML = arrow(-1, pg === 1) + nums.map(function (n) {
          return n === '…' ? '<span class="at-jr__dots">…</span>' : '<button type="button" class="at-jr__pg' + (n === pg ? ' is-on' : '') + '" data-pg="' + n + '"' + (n === pg ? ' aria-current="page"' : '') + '>' + n + '</button>';
        }).join('') + arrow(1, pg === pages) + '<span class="at-jr__pginfo">' + ((pg - 1) * PER + 1) + '-' + Math.min(pg * PER, list.length) + ' / ' + list.length + ' vélemény</span>';
      }
      pager.addEventListener('click', function (e) { var b = e.target.closest('[data-pg]'); if (b && !b.disabled) goPage(+b.dataset.pg); });
      if (more) more.addEventListener('click', expand);
      document.addEventListener('click', function (e) {
        if (!e.target.closest('.jdgm-prev-badge, .jdgm-preview-badge')) return;
        e.preventDefault(); e.stopPropagation(); sec.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }, true);
      var CK = 'atjr:' + grid.dataset.pid;
      function load() {
        var all = [];
        /* 30 percig a böngészőben tárolva, hogy termékek közti lapozáskor ne töltse le újra */
        try { var c = JSON.parse(sessionStorage.getItem(CK) || 'null'); if (c && Date.now() - c.t < 18e5 && c.l && c.l.length) { all = c.l; return done(true); } } catch (e) {}
        page(1).then(function (j) {
          all = parse(j.html);
          var total = +j.total_count || 0, pages = Math.min(30, Math.ceil(total / 30)), rest = [];
          for (var n = 2; n <= pages; n++) rest.push(n);
          /* a többi oldal párhuzamosan, egyszerre legfeljebb 4 kérés */
          var i = 0, running = 0;
          if (!rest.length) return done();
          (function pump() {
            while (running < 4 && i < rest.length) {
              running++;
              page(rest[i++]).then(function (r) { all = all.concat(parse(r.html)); }).catch(function () {}).then(function () { running--; if (i >= rest.length && !running) done(); else pump(); });
            }
          })();
        }).catch(fallback);
        function done(cached) {
          var seen = {}; all = all.filter(function (r) { if (!r.name || !(r.body || r.title || r.pics.length) || seen[r.id]) return false; seen[r.id] = 1; return true; });
          if (!cached) { try { sessionStorage.setItem(CK, JSON.stringify({ t: Date.now(), l: all })); } catch (e) {} }
          list = all.filter(function (r) { return r.pics.length; }).concat(all.filter(function (r) { return !r.pics.length; }));
          grid.innerHTML = '';
          if (!list.length) { fallback(); return; }
          teaser();
        }
      }
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (es) { if (es[0].isIntersecting) { io.disconnect(); load(); } }, { rootMargin: '800px 0px' });
        io.observe(sec);
      } else load();
    });
  }

  /* ---------- termékoldal: csomag összeállító ---------- */
  function bb() {
    document.querySelectorAll('[data-at-bb]').forEach(function (root) {
      if (root.dataset.atInit) return; root.dataset.atInit = 1;
      var P; try { P = JSON.parse(root.querySelector('[data-at-bb-data]').textContent); } catch (e) { return; }
      if (!P.length) { root.hidden = true; return; }
      var cur = P[0], d2 = +root.dataset.d2 || 0, d3 = +root.dataset.d3 || 0, n = +root.dataset.start || 2;
      var slotsEl = root.querySelector('[data-at-bb-slots]'), oldEl = root.querySelector('[data-at-bb-old]'), newEl = root.querySelector('[data-at-bb-new]');
      var saveEl = root.querySelector('[data-at-bb-save]'), btn = root.querySelector('[data-at-bb-add]'), msg = root.querySelector('[data-at-bb-msg]');
      var tiers = root.querySelectorAll('.at-bb__tiers [data-n]');
      function esc(t) { var d = document.createElement('div'); d.textContent = t == null ? '' : t; return d.innerHTML; }
      function firstAvail(p) { for (var i = 0; i < p.v.length; i++) if (p.v[i].a) return p.v[i]; return p.v[0]; }
      /* aktuális termék változata a fő űrlapból (ha van) */
      function mainVariant() {
        var f = document.querySelector('product-info form[data-type="add-to-cart-form"] input[name="id"], form[action*="/cart/add"] input[name="id"]');
        var id = f ? +f.value : 0; for (var i = 0; i < cur.v.length; i++) if (cur.v[i].id === id) return cur.v[i]; return firstAvail(cur);
      }
      /* alap választás a szekció beállításai szerint (2. hely: def2, 3. hely: def3 + változat szűrő, pl. „Krémes”) */
      var others = P.slice(1);
      function byId(id) { id = +id; if (!id) return null; for (var i = 0; i < P.length; i++) if (P[i].id === id) return P[i]; return null; }
      function pickVariant(p, m) {
        if (m) { m = m.toLowerCase(); for (var i = 0; i < p.v.length; i++) if (p.v[i].a && p.v[i].t.toLowerCase().indexOf(m) > -1) return p.v[i]; }
        return firstAvail(p);
      }
      var p2 = byId(root.dataset.def2) || others[0] || cur;
      var p3 = byId(root.dataset.def3) || others.filter(function (p) { return p !== p2; })[0] || cur;
      var picks = [{ p: cur, v: mainVariant(), lock: true },
        { p: p2, v: firstAvail(p2) },
        { p: p3, v: pickVariant(p3, root.dataset.def3v) }];
      function slotHTML(s, i) {
        var opts = '';
        if (!s.lock) {
          opts = '<select class="at-bb__prod" data-i="' + i + '" aria-label="Termék választása">' +
            '<option value="' + cur.id + '"' + (s.p === cur ? ' selected' : '') + '>' + esc(root.dataset.same) + ' (' + esc(cur.t) + ')</option>' +
            others.map(function (p) { return '<option value="' + p.id + '"' + (s.p === p ? ' selected' : '') + '>' + esc(p.t) + '</option>'; }).join('') + '</select>';
        }
        var vs = s.p.v.length > 1 ? '<select class="at-bb__var" data-at-vp data-i="' + i + '" aria-label="Változat">' + s.p.v.map(function (v) {
          return '<option value="' + v.id + '"' + (v === s.v ? ' selected' : '') + (v.a ? '' : ' disabled') + ' data-o1="' + esc(v.o1 || '') + '" data-o2="' + esc(v.o2 || '') + '"' + (v.sw ? ' data-sw="' + esc(v.sw) + '"' : '') + '>' + esc(v.t) + (v.a ? '' : ' - elfogyott') + '</option>';
        }).join('') + '</select>' : '';
        return '<div class="at-bb__slot' + (s.lock ? ' is-lock' : '') + '">' +
          '<div class="at-bb__pic"><img src="' + esc(s.v.img || s.p.img) + '" alt="' + esc(s.p.t) + '" loading="lazy"><span class="at-bb__num">' + (i + 1) + '</span></div>' +
          '<div class="at-bb__info">' + (s.lock ? '<small>Ez a termék</small><b>' + esc(cur.t) + '</b>' : opts) + vs +
          '<span class="at-bb__price">' + money(s.v.p) + '</span></div></div>';
      }
      function render() {
        tiers.forEach(function (t) { var on = +t.dataset.n === n; t.classList.toggle('is-on', on); t.setAttribute('aria-checked', on); });
        var html = '';
        for (var i = 0; i < n; i++) { if (i) html += '<span class="at-bb__plus" aria-hidden="true">+</span>'; html += slotHTML(picks[i], i); }
        slotsEl.innerHTML = html; slotsEl.dataset.n = n; vpAll(slotsEl); total();
      }
      function total() {
        var t = 0, ok = true; for (var i = 0; i < n; i++) { t += picks[i].v.p; if (!picks[i].v.a) ok = false; }
        var pct = n >= 3 ? d3 : d2, fin = Math.round(t * (100 - pct) / 100 / 100) * 100;
        oldEl.textContent = money(t); newEl.textContent = money(fin);
        saveEl.textContent = 'Megtakarítás: ' + money(t - fin) + ' (-' + pct + '%)';
        btn.disabled = !ok;
      }
      tiers.forEach(function (t) { t.addEventListener('click', function () { n = +t.dataset.n; render(); }); });
      slotsEl.addEventListener('change', function (e) {
        var el = e.target, i = +el.dataset.i, s = picks[i]; if (!s) return;
        if (el.classList.contains('at-bb__prod')) {
          var id = +el.value; s.p = id === cur.id ? cur : others.filter(function (p) { return p.id === id; })[0] || cur; s.v = firstAvail(s.p); render();
        } else if (el.classList.contains('at-bb__var')) {
          var vid = +el.value; s.v = s.p.v.filter(function (v) { return v.id === vid; })[0] || s.v;
          var im = el.closest('.at-bb__slot').querySelector('img'); if (im) im.src = s.v.img || s.p.img;
          var pr = el.closest('.at-bb__slot').querySelector('.at-bb__price'); if (pr) pr.textContent = money(s.v.p);
          total();
        }
      });
      /* ha a fő űrlapon színt/méretet váltanak, az 1. hely kövesse */
      document.addEventListener('change', function (e) {
        if (root.contains(e.target)) return;
        setTimeout(function () { var v = mainVariant(); if (v && v !== picks[0].v) { picks[0].v = v; render(); } }, 60);
      });
      btn.addEventListener('click', function () {
        var map = {}, items = [];
        for (var i = 0; i < n; i++) { var id = picks[i].v.id; map[id] = (map[id] || 0) + 1; }
        for (var k in map) items.push({ id: +k, quantity: map[k] });
        btn.disabled = true; var lbl = btn.textContent; btn.textContent = 'Hozzáadás…'; msg.textContent = '';
        addItems(items).then(function () { window.location.href = (window.routes && window.routes.cart_url) || '/cart'; })
          .catch(function (err) { btn.disabled = false; btn.textContent = lbl; msg.textContent = (err && err.description) || 'Hiba történt, próbáld újra.'; });
      });
      render();
    });
  }

  /* ---------- változatválasztó: előbb méret, utána szín színpöttyel ---------- */
  var VP_COL = { 'fekete': '#1d1d1f', 'krémes fehér': '#eee8da', 'fehér': '#f4f4f2', 'sötétkék': '#1f2e4a', 'felhő kék': '#a9c3d6', 'piros': '#c8323c',
    'lila': '#8b7fb3', 'türkiz kék': '#4fa3b3', 'türkiz': '#4fa3b3', 'levendula': '#b6a6d8', 'rózsaszín': '#eaa7ba', 'világos kék': '#9ed4f0', 'babakék': '#9ed4f0',
    'kék': '#3d7fc1', 'halvány olivazöld': '#a8b18d', 'olivazöld': '#8a9a5b', 'zöld': '#5c9a5b', 'sárga': '#f2c84b', 'narancs': '#f08a3c', 'szürke': '#9a9ea3', 'bézs': '#d9c7a7', 'barna': '#7a5638' };
  function vpColor(name, sw) { if (sw) return sw; var k = (name || '').toLowerCase().trim(); if (VP_COL[k]) return VP_COL[k]; for (var c in VP_COL) if (k.indexOf(c) > -1) return VP_COL[c]; return ''; }
  function vpSize(s) { return (s || '').replace(/(\d)\s*ml/i, '$1 ml'); }
  var vpOpen = null;
  function vpClose() { if (!vpOpen) return; vpOpen.panel.hidden = true; if (vpOpen.panel.parentNode !== vpOpen.wrap) vpOpen.wrap.appendChild(vpOpen.panel); vpOpen.btn.setAttribute('aria-expanded', 'false'); document.documentElement.classList.remove('at-vp-lock'); vpOpen = null; }
  document.addEventListener('click', function (e) { if (vpOpen && !vpOpen.wrap.contains(e.target)) vpClose(); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') vpClose(); });
  function vpAll(root) { (root || document).querySelectorAll('select[data-at-vp]').forEach(vp); }
  function vp(sel) {
    if (sel.dataset.vpInit || sel.hidden) return;
    var opts = [].slice.call(sel.options).map(function (o) { return { o: o, s: o.dataset.o1 || '', c: o.dataset.o2 || '', sw: o.dataset.sw || '', dis: o.disabled }; });
    if (!opts.length || !opts.some(function (x) { return x.s || x.c; })) return;
    sel.dataset.vpInit = 1;
    var sizes = []; opts.forEach(function (x) { if (x.s && sizes.indexOf(x.s) < 0) sizes.push(x.s); });
    sizes.sort(function (a, b) { return (parseFloat(a) || 0) - (parseFloat(b) || 0); });
    var wrap = document.createElement('div'); wrap.className = 'at-vp';
    var btn = document.createElement('button'); btn.type = 'button'; btn.className = 'at-vp__btn'; btn.setAttribute('aria-haspopup', 'listbox'); btn.setAttribute('aria-expanded', 'false');
    var panel = document.createElement('div'); panel.className = 'at-vp__panel'; panel.hidden = true; panel.setAttribute('role', 'dialog'); panel.setAttribute('aria-label', 'Változat választása');
    sel.parentNode.insertBefore(wrap, sel); wrap.appendChild(sel); wrap.appendChild(btn); wrap.appendChild(panel);
    sel.classList.add('at-vp__native'); sel.tabIndex = -1; sel.setAttribute('aria-hidden', 'true');
    var curSize = null;
    function cur() { var o = sel.options[sel.selectedIndex]; for (var i = 0; i < opts.length; i++) if (opts[i].o === o) return opts[i]; return opts[0]; }
    function dot(x, cls) { var col = vpColor(x.c, x.sw); return '<i class="at-vp__dot' + (cls || '') + '"' + (col ? ' style="--c:' + col + '"' : '') + '></i>'; }
    function label() {
      var x = cur(); btn.innerHTML = '<span class="at-vp__val">' + (x.c ? dot(x) : '') + '<span>' + [x.s ? vpSize(x.s) : '', x.c].filter(Boolean).join(' · ') + '</span></span><svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6 9l6 6 6-6"/></svg>';
    }
    function esc2(t) { var d = document.createElement('div'); d.textContent = t; return d.innerHTML; }
    function draw() {
      var x = cur(); if (curSize === null) curSize = x.s;
      var html = '<div class="at-vp__head"><b>' + (sizes.length > 1 ? 'Válassz méretet' : 'Válassz színt') + '</b><button type="button" class="at-vp__x" aria-label="Bezárás">✕</button></div>';
      if (sizes.length > 1) {
        html += '<div class="at-vp__sizes">' + sizes.map(function (s) {
          var any = opts.some(function (y) { return y.s === s && !y.dis; });
          return '<button type="button" class="at-vp__size' + (s === curSize ? ' is-on' : '') + '" data-s="' + esc2(s) + '"' + (any ? '' : ' disabled') + '>' + esc2(vpSize(s)) + '</button>';
        }).join('') + '</div><b class="at-vp__sub">Szín</b>';
      }
      var list = opts.filter(function (y) { return sizes.length > 1 ? y.s === curSize : true; });
      html += '<div class="at-vp__cols">' + list.map(function (y) {
        return '<button type="button" class="at-vp__col' + (y.o === x.o ? ' is-on' : '') + '" data-v="' + y.o.value + '"' + (y.dis ? ' disabled' : '') + '>' + dot(y) + '<span>' + esc2(y.c || vpSize(y.s)) + (y.dis ? ' <small>elfogyott</small>' : '') + '</span></button>';
      }).join('') + '</div>';
      panel.innerHTML = html;
    }
    btn.addEventListener('click', function (e) {
      e.preventDefault(); e.stopPropagation();
      if (vpOpen && vpOpen.panel === panel) { vpClose(); return; }
      vpClose(); curSize = null; draw(); panel.hidden = false; btn.setAttribute('aria-expanded', 'true'); vpOpen = { wrap: wrap, panel: panel, btn: btn };
      if (window.matchMedia('(max-width: 749px)').matches) { document.body.appendChild(panel); document.documentElement.classList.add('at-vp-lock'); }
      var f = panel.querySelector('.is-on') || panel.querySelector('button:not([disabled]):not(.at-vp__x)'); if (f) f.focus({ preventScroll: true });
    });
    panel.addEventListener('click', function (e) {
      e.preventDefault(); e.stopPropagation();
      var t = e.target.closest('button'); if (!t || t.disabled) return;
      if (t.classList.contains('at-vp__x')) { vpClose(); btn.focus(); return; }
      if (t.dataset.s != null) { curSize = t.dataset.s; draw(); var c = panel.querySelector('.at-vp__col:not([disabled])'); if (c) c.focus({ preventScroll: true }); return; }
      if (t.dataset.v) { sel.value = t.dataset.v; sel.dispatchEvent(new Event('change', { bubbles: true })); label(); vpClose(); btn.focus(); }
    });
    sel.addEventListener('change', label);
    label();
  }
  /* változatkép: Gyakran együtt + főoldali csomagok (option data-img) */
  function vimg(sel) {
    var it = sel.closest('[data-at-fbt-item], .at-bundle__it'); if (!it) return;
    var img = it.querySelector('img'), o = sel.selectedOptions && sel.selectedOptions[0]; if (!img || !o) return;
    if (!img.dataset.orig) { img.dataset.orig = img.currentSrc || img.src; img.dataset.origSet = img.getAttribute('srcset') || ''; }
    var u = o.dataset.img;
    if (u) { img.removeAttribute('srcset'); img.removeAttribute('sizes'); if (img.getAttribute('src') !== u) img.src = u; }
    else { img.src = img.dataset.orig; if (img.dataset.origSet) img.setAttribute('srcset', img.dataset.origSet); }
  }
  document.addEventListener('change', function (e) { if (e.target.matches && e.target.matches('[data-at-fbt-item] select, .at-bundle__it select')) vimg(e.target); });
  function vimgAll() { document.querySelectorAll('[data-at-fbt-item] select, .at-bundle__it select').forEach(function (s) { if (s.selectedOptions[0] && s.selectedOptions[0].dataset.img) vimg(s); }); }
  function init() { reveal(); lazyVids(); vt(); vwraps(); heroes(); grids(); bundles(); fbt(); sticky(); jr(); bb(); vpAll(); vimgAll(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', function (e) { init(); reveal(e.target); });
})();
